import React, { useEffect, useState } from "react";
import Text from "theme/Text";
import { useRoute } from "@react-navigation/native";
import i18n from "utils/i18n";
import * as Linking from 'expo-linking';
import Button from "theme/Button";
import _ from "lodash";
import { PlaceholderBooking } from "placeholders";
import { textStyles } from "styles/text";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedBlock from "components/atoms/ThemedBlock";
import { StyleSheet, View } from "react-native";
import { ThemedSizes, ThemedValues } from "styles/themed";
import HelperSetting from "utils/helper-setting";
import { settingsConstants } from "utils/constants/settings-constants";
import EmployeeCard, { EmployeeCardModes, EmployeeCardShowERO } from "components/molecules/EmployeeCard";
import { useSelector } from 'react-redux'
import selectEmployeeEros from 'services/redux/data/selectors/selectEmployeeEros'
import { openUrl } from 'utils/helper-url'
import HelperDate from 'utils/helper-date'
import VStack from 'components/atoms/stack/VStack'

const HomeCoworkerViewEroScene = () => {

	const route = useRoute();

	const _employeeEros = useSelector( selectEmployeeEros )

	const [ loading, setLoading ] = useState( true )
	const [ refreshing, setRefreshing ]= useState( false )
	const [ employee, setEmployee] = useState( null )

	const getLinkingTel = () => {
		return `tel:${employee.phonenumber}`;
	}

	const onPressCall = () => {
		const url = getLinkingTel();

		if( Linking.canOpenURL( url ) ) {
			openUrl( url );
		}
	}

	const getLinkingEmergency = () => {
		return `tel:${HelperSetting.get( settingsConstants.EMERGENCY_NUMBER ) }`;
	}

	const onPressEmergencyCall = () => {
		const url = getLinkingEmergency();

		if( Linking.canOpenURL( url ) ) {
			openUrl( url );
		}
	}

	// On start
	useEffect(() => {
		const routeEmployee = _.get( route, ['params', 'employee'], {} );
		const employee = _.find( _employeeEros, { guid: routeEmployee } );

		setEmployee( employee );
		setLoading( false );
	}, [ _employeeEros ]);

	return (
		<ThemedSafeAreaComponentTop
			top={false}>

			<ThemedLayout
				topNavigation={ true }
				showBackButton={ true }
				title={ i18n.t('page.ero.title') }
				subtitle={ _.get( employee, 'name', '?') }>

				<Choose>
					<When condition={ loading && !refreshing }>
						<PlaceholderBooking />
					</When>
					<Otherwise>
						<VStack space={ ThemedValues.stackSpace }>
							<ThemedBlock
								smallPadding
								shadow>
	
								<EmployeeCard
									mode={ EmployeeCardModes.listItem }
									employee={ employee }
									avatarSize={ ThemedSizes.M }
									avatarShowIconEro={ true }
									avatarShowIconConfidant={ true }
									show={ EmployeeCardShowERO }
									showDetails={ true }
									selectedLocationDate={ HelperDate.date() }
								/>
							</ThemedBlock>
							
							<ThemedBlock
								smallPadding
								shadow>
								
								<View>
									<Text style={ textStyles.textCenter }>
										{ i18n.t('page.ero.call_description') }
									</Text>
	
									<Button onPress={ onPressCall }>
										{ i18n.t('page.ero.button_call', {name: employee?.name }) }
									</Button>
								</View>
	
								{ Linking.canOpenURL( getLinkingEmergency() ) && (
									<View style={ staticStyles.viewMarginTop16 }>
										<Text style={ textStyles.textCenter }>
											{ i18n.t('page.ero.emergency_description') }
										</Text>
	
										<Button onPress={ onPressEmergencyCall }>
											{ i18n.t('page.ero.button_emergency', { number: HelperSetting.get( settingsConstants.EMERGENCY_NUMBER ) }) }
										</Button>
									</View>
								)}
							</ThemedBlock>
						</VStack>
					</Otherwise>
				</Choose>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const staticStyles = StyleSheet.create({
	viewMarginTop16: {
		marginTop: 16,
	},
});

export default HomeCoworkerViewEroScene
